/**
 * AWS リソース設定（公開情報のみ）。
 *
 * Cognito UserPool ID / Client ID / AppSync エンドポイントはクライアント側で
 * 露出する情報のため、git 追跡対象としてここに直接記載する。
 * 秘匿情報（API キーや IAM 認証情報）はここに置かない。
 *
 * CDK 構成を変更した場合は `cdk deploy` 後に CloudFormation Outputs の値で
 * 本ファイルを更新する。値の取得方法:
 * Cognito は onocomm-identity-platform の共通 UserPool と本サービス専用 Client を利用する。
 *   aws cloudformation describe-stacks --stack-name LoopDashboardBackend \
 *     --query "Stacks[0].Outputs[?OutputKey=='GraphqlApiUrl'].OutputValue" \
 *     --output text --profile loophamburg
 */

export const AWS_CONFIG = {
  region: 'ap-northeast-1',
  cognito: {
    userPoolId: 'ap-northeast-1_HHke70QHh',
    userPoolClientId: '1s5gdiie1d1mok5u8jtbp06g5n',
    managedLoginDomain: 'login.onocomm.jp',
    redirectSignIn: 'https://dashboard.loop2014.co.jp/auth/callback',
    redirectSignOut: 'https://dashboard.loop2014.co.jp/',
    accountCenterUrl: 'https://account.onocomm.jp/?from=loop-dashboard',
  },
  graphql: {
    endpoint:
      'https://2mw4dipv6beufarg3iwl6qff3u.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  },
} as const;
